import { AddButton, PlusIcon, SlideContainer, SlideLabel } from './styles'

interface AddCardSlideProps {
  /** 슬라이드 텍스트 — 카드 0개면 "카드를 등록해 주세요", 1개 이상이면 "결제 카드 추가" */
  label: string
  onClick: () => void
  /** 캐러셀 선택 감지용 sentinel id — add 슬라이드 활성 여부(결제 불가) 판별에 사용 */
  slideId?: string
}

/**
 * 카드 캐러셀 마지막 슬라이드 — 카드 등록 진입점.
 *
 * 시안:
 *  - PaymentStep 캐러셀 (18850:202306) 마지막 슬라이드
 *  - 카드 empty state (5326:74900) 단독
 *
 * 같은 컴포넌트로 흡수 — label만 분기.
 */
export function AddCardSlide({ label, onClick, slideId }: AddCardSlideProps) {
  return (
    <SlideContainer
      type='button'
      data-card-id={slideId}
      onClick={onClick}
    >
      <AddButton>
        <PlusIcon />
      </AddButton>
      <SlideLabel>{label}</SlideLabel>
    </SlideContainer>
  )
}
